import React, { useEffect, useRef } from 'react';
import { PhoneDetails } from '@bb/domain/dist/types/AppointmentConfig';
import { ExternalDashboardNotificationsDTO } from 'api/AppExternalController/getDashboardNotifications';
import { Input } from 'components';
import { getPhoneInputMask } from 'utils';
import styled from 'styled-components';

const PhoneNumber: React.FC<
  PhoneDetails & { onSMSChange: () => void; onPhoneChange: (e: any) => void }
> = ({ number, sendSms, onSMSChange, onPhoneChange }) => {
  const phoneRef = useRef<HTMLInputElement>();

  useEffect(() => {
    if (phoneRef.current) {
      getPhoneInputMask().mask(phoneRef.current);
    }
  }, [phoneRef.current]);

  return (
    <StyledPhoneDetails className="row">
      <div className="col-12">
        <StyledPhoneEntry className="input-group">
          <span
            className="input-group-addon"
            style={{ backgroundColor: '#007bff' }}
          >
            <i className="fa fa-phone text-white"></i>
          </span>
          <input
            type="text"
            value={number}
            onChange={onPhoneChange}
            className="form-control"
            placeholder="Enter Phone Number"
            data-cy="phone-number"
            ref={phoneRef}
          />
        </StyledPhoneEntry>
      </div>
      <StyledPadTop>
        <div className="col-sm-4 text-center">
          <div className="no-padding">
            <label>
              SEND SMS{' '}
              <input
                type="checkbox"
                checked={sendSms}
                onChange={onSMSChange}
                data-cy="phone-send-sms"
              />
            </label>
          </div>
        </div>
      </StyledPadTop>
    </StyledPhoneDetails>
  );
};

const ExternalNotificationDeliveryOptions = ({
  deliveries,
  phone,
  email,
  toggleEmails,
  toggleSms,
  setPhone,
}: ExternalDashboardNotificationsDTO & {
  toggleEmails: () => void;
  toggleSms: (index: number) => void;
  setPhone: (index: number, phone: string) => void;
}) => (
    <div className="col-md-5">
      <h5>Receive Notifications By</h5>
      <div className="appointment-small appointment-margin-top">
        <div className="form-group">
          <label>Email: (Please contact the brokerage to change)</label>
          <div className="row">
            <div className="input-group" style={{ paddingLeft: '15px' }}>
              <span
                className="input-group-addon"
                style={{ backgroundColor: '#007bff' }}
              >
                <i className="fa fa-at text-white"></i>
              </span>

              <StyledInput value={email} disabled />
            </div>
          </div>
          <StyledPadTop>
            <div className="no-padding">
              <div>
                <label>
                  SEND EMAILS{' '}
                  <input
                    type="checkbox"
                    checked={deliveries?.Email}
                    onChange={toggleEmails}
                    disabled={!email}
                  />
                </label>
              </div>
            </div>
          </StyledPadTop>
        </div>
        {phone?.length > 0 && (
          <>
            <label>Phone{phone.length > 1 ? 's' : ''}</label>
            {phone.map((phoneData, index) => (
              <PhoneNumber
                key={index}
                onSMSChange={() => toggleSms(index)}
                onPhoneChange={(e: any) => setPhone(index, e.target.value)}
                {...phoneData}
              />
            ))}
          </>
        )}
      </div>
    </div>
  );

const StyledInput = styled(Input)`
  [disabled] {
    color: #555;
  }
`;

const StyledPhoneDetails = styled.div`
  padding-bottom: 10px;
`;

const StyledPadTop = styled.div`
  padding-top: 4px;
`;

const StyledPhoneEntry = styled.div`
  padding-left: 15px;
`;

export default ExternalNotificationDeliveryOptions;
